import React from 'react'
import Blog from '../Blog'

function MyBlogs() {
  
  return (
    <div>
     <Blog  type={"USER_BLOG"}  />
    </div>
  )
}

export default MyBlogs